<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Nova Requisição de Balcão
        </p>
      </div>
    </div>
    <div class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-2">
        <div>Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div class="col-2">
        <div>Requisição Para</div>
        <q-select
          :options="options.requisicaoPara"
          v-model="filtros.requisicaoPara"
          dense
          outlined
        />
      </div>
      <div class="col-2">
        <div>Solicitante</div>
        <SelecaoFuncionario @emitirFuncionario="receberFuncionario" />
      </div>
    </div>
    <div class="q-mt-xl" v-if="filtros.requisicaoPara?.value == 'visitante'">
      <div
        class="text-h6 text-titulo-grupo text-brand-5 text-weight-bold q-mb-md"
      >
        Selecione o centro de Custo
      </div>

      <section style="width: 100%" class="row text-brand-5">
        <div class="row q-mt-lg text-weight-regular">
          <div
            class="container-radio-solicitante"
            v-for="(centro, index) in listaCentros"
            :key="index"
          >
            <q-radio
              class="radio-grupo-produto"
              :val="centro"
              :label="`${centro.code}-${centro.name}`"
              v-model="centroSelecionado"
            ></q-radio>
          </div>
        </div>
        <span
          class="row q-pa-md col-12 text-bold text-black texto-alerta"
          style="background-color: #b3e5be; border-radius: 5px"
          v-if="listaCentros.length <= 0"
          >Nenhum centro de custo encontrado</span
        >
      </section>
    </div>
    <div class="row col-12 q-mt-xl text-brand-5">
      <span class="text-weight-bold col-12" style="font-size: 18px"
        >Tipo de Requisição</span
      >
      <div class="row col-12 q-mt-sm">
        <q-radio
          val="all"
          label="Todos"
          v-model="filtros.tipoRequisicao"
        ></q-radio>
        <q-radio
          v-if="
            filtros.requisicaoPara?.value == 'colaborador' ||
            filtros.tipoRequisicao == 'requisicaoMaterial'
          "
          val="liberados"
          label="Produtos Liberados"
          v-model="filtros.tipoRequisicao"
        ></q-radio>
        <q-radio
          v-if="filtros.requisicaoPara?.value != 'visitante'"
          val="yes"
          label="Todos EPI"
          v-model="filtros.tipoRequisicao"
        ></q-radio>
      </div>
    </div>
    <div class="q-mt-xl container">
      <div class="column col-12 text-brand-5 q-mt-xl q-mb-xl"></div>
      <div class="col-12">
        <div
          class="row justify-between text-h6 container-texto-input-search text-brand-5 text-weight-bold q-mt-lg q-mb-lg"
        >
          <span class="q-mb-md">Selecione os Produtos para Requisição</span>

          <div class="row">
            <div class="input-search-table">
              <q-input
                rounded
                outlined
                dense
                debounce="300"
                v-model="filtros.produto"
                type="text"
                placeholder="Pesquisar"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
            <div>
              <q-toggle
                class="texto-toggle"
                v-model="listarTodos"
                label="Com Saldo"
              />
            </div>
          </div>
        </div>
        <div>
          <q-linear-progress
            size="xs"
            class="q-mt-sm"
            v-if="loading"
            indeterminate
          />
          <q-table
            :grid="$q.screen.lt.sm"
            :rows="listaProdutos"
            color="primary"
            :columns="columns"
            selection="multiple"
            row-key="code"
            class="my-sticky-dynamic"
            flat
            dense
            hide-pagination
            :loading="loading"
            hide-bottom
            v-model:selected="selected"
          >
            <template v-slot:item="props">
              <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
                <div class="row card">
                  <div class="col-3 q-mr-sm text-center q-mt-md">
                    <div
                      v-if="props.row.product_images.length != 0"
                      class="img-container-grid q-ml-sm"
                    >
                      <q-img
                        v-if="props.row.product_images.length != 0"
                        :src="props.row.product_images[0].url"
                        fit="contain"
                        class="img-grid"
                      />
                    </div>
                    <div class="img-container-grid q-ml-sm" v-else>
                      <span class="img-grid"></span>
                    </div>
                  </div>
                  <div class="col">
                    <q-card-section class="row text-brand-5 text-grid-table">
                      <div class="col-12" style="margin-bottom: 3px">
                        <span
                          ><strong>Código:</strong> {{ props.row?.code }}</span
                        >
                        <span class="q-ml-sm"
                          ><strong>Nome:</strong> {{ props.row?.name }}</span
                        >
                      </div>
                      <div class="col-12" style="margin-bottom: 3px">
                        <span
                          ><strong>Estoque:</strong>
                          {{
                            parseInt(
                              props.row?.stock[0]?.pivot?.amount
                            ).toFixed(2)
                          }}</span
                        >
                      </div>
                      <q-td v-if="filtros.tipoRequisicao == 'liberados'">
                        {{
                          `${props.row?.pode_retirar}(${
                            parseFloat(props.row?.max_amount) -
                              parseFloat(props.row?.withdrawal_amount) >
                            0
                              ? parseFloat(props.row?.max_amount) -
                                parseFloat(props.row?.withdrawal_amount)
                              : "0"
                          })`
                        }}
                      </q-td>
                      <div class="col-12">
                        <div class="col-12">
                          <div class="text-brand-5 btn-grid-container">
                            <div class="row col-12 items-center">
                              <div class="q-mr-sm">
                                <p></p>
                                <q-icon
                                  name="arrow_left"
                                  class="arrow"
                                  style="background: #6391f4"
                                  @click="
                                    props.row.amount != null &&
                                    props.row.amount > 0
                                      ? props.row.amount--
                                      : ''
                                  "
                                />
                              </div>
                              <div
                                class="row col-2 justify-center input-quantidade-container"
                                style="border-bottom: 1px solid #505050"
                              >
                                <q-input
                                  class="input-quantidade"
                                  borderless
                                  dense
                                  type="number"
                                  v-model="props.row.amount"
                                  min="0"
                                />
                              </div>
                              <div class="q-ml-sm">
                                <p></p>
                                <q-icon
                                  name="arrow_right"
                                  class="arrow"
                                  style="background: #6391f4"
                                  @click="
                                    props.row.amount == null
                                      ? (props.row.amount = 1)
                                      : props.row.amount++
                                  "
                                />
                              </div>
                              <div class="q-ml-md">
                                <p></p>
                                <q-btn
                                  :text-color="props.selected ? 'black' : ''"
                                  :color="props.selected ? 'accent' : 'primary'"
                                  label="Selecionar"
                                  @click="props.selected = !props.selected"
                                  :disable="props.selected"
                                  no-caps
                                  dense
                                  size="11px"
                                  :icon="
                                    props.selected
                                      ? 'check_circle_outline'
                                      : 'add_circle_outline'
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </q-card-section>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                  <span v-if="filtros.tipoRequisicao == 'liberados'">{{
                    col.label
                  }}</span>
                  <span v-else>{{
                    col.label == "Pode Retirar?" ? "" : col.label
                  }}</span>
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr>
                <q-td>
                  <q-btn
                    class="q-ml-md"
                    :color="props.selected ? 'red' : 'secondary'"
                    round
                    :disable="props.selected"
                    no-caps
                    dense
                    :icon="props.selected ? 'close' : 'add'"
                    @click="props.selected = !props.selected"
                  />
                </q-td>
                <q-td>
                  <div
                    v-if="props.row.product_images.length != 0"
                    class="img-container"
                  >
                    <q-img
                      v-if="props.row.product_images.length != 0"
                      :src="props.row.product_images[0].url"
                      fit="contain"
                      style="max-width: 100%; height: 45px"
                    />
                  </div>
                  <div class="img-container" v-else>
                    <span class="img-normal"></span>
                  </div>
                </q-td>
                <q-td>
                  <span>{{ props.row?.code }}</span>
                </q-td>
                <q-td>
                  <span>{{ props.row?.name }}</span>
                </q-td>
                <q-td>
                  <span>{{
                    parseInt(props.row?.stock[0]?.pivot?.amount).toFixed(2)
                  }}</span>
                </q-td>
                <q-td>
                  <div>
                    <q-input
                      v-model.number="props.row.amount"
                      type="number"
                      style="width: 60px; max-width: 100px"
                      min="0"
                      outlined
                      dense
                    />
                  </div>
                </q-td>
                <q-td v-if="filtros.tipoRequisicao == 'liberados'">
                  <span>{{
                    `${props.row?.pode_retirar}(${
                      parseFloat(props.row?.max_amount) -
                        parseFloat(props.row?.withdrawal_amount) >
                      0
                        ? parseFloat(props.row?.max_amount) -
                          parseFloat(props.row?.withdrawal_amount)
                        : "0"
                    })`
                  }}</span>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </div>
      <div class="q-mt-xl q-mb-lg" v-if="selected.length > 0">
        <div
          class="text-h6 text-titulo-grupo text-brand-5 text-weight-bold q-mb-xl"
        >
          Produtos Selecionados
        </div>
        <q-table
          :grid="$q.screen.lt.sm"
          table-header-class="bg-accent text-width-bold"
          :columns="columns2"
          :rows="selected"
          hide-pagination
          hide-bottom
          dense
          :rows-per-page-options="[0]"
          flat
        >
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col-3 q-mr-sm text-center q-mt-md">
                  <div
                    v-if="props.row.product_images.length != 0"
                    class="img-container-grid q-ml-sm"
                  >
                    <q-img
                      v-if="props.row.product_images.length != 0"
                      :src="props.row.product_images[0].url"
                      fit="contain"
                      class="img-grid"
                    />
                  </div>
                  <div class="img-container-grid q-ml-sm" v-else>
                    <span class="img-grid"></span>
                  </div>
                </div>
                <div class="col">
                  <q-card-section class="row text-brand-5 text-grid-table">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Código:</strong> {{ props.row?.code }}</span
                      >
                      <span class="q-ml-sm"
                        ><strong>Nome:</strong> {{ props.row?.name }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque:</strong>
                        {{
                          parseInt(props.row.stock[0]?.pivot?.amount).toFixed(2)
                        }}</span
                      >
                    </div>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div class="q-mr-sm">
                              <p></p>
                              <q-icon
                                name="arrow_left"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.amount != null &&
                                  props.row.amount > 0
                                    ? props.row.amount--
                                    : ''
                                "
                              />
                            </div>
                            <div
                              class="row col-2 justify-center input-quantidade-container"
                              style="border-bottom: 1px solid #505050"
                            >
                              <q-input
                                class="input-quantidade"
                                borderless
                                dense
                                type="number"
                                v-model="props.row.amount"
                                min="0"
                              />
                            </div>
                            <div class="q-ml-sm">
                              <p></p>
                              <div class="arrow-container">
                                <q-icon
                                  name="arrow_right"
                                  class="arrow"
                                  style="background: #6391f4"
                                  @click="
                                    props.row.amount == null
                                      ? (props.row.amount = 1)
                                      : props.row.amount++
                                  "
                                />
                              </div>
                            </div>
                            <div class="row col justify-center q-ml-xl">
                              <div>
                                <p></p>
                                <q-icon
                                  name="close"
                                  style="
                                    font-size: 28px;
                                    margin: 0px 0px 3px 0px;
                                    cursor: pointer;
                                  "
                                  color="red"
                                  @click="removerProduto(props.row.id)"
                                ></q-icon>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                <span v-if="filtros.tipoRequisicao == 'liberados'">{{
                  col.label
                }}</span>
                <span v-else>{{
                  col.label == "Pode Retirar?" ? "" : col.label
                }}</span>
              </q-th>
            </q-tr>
          </template>
          <template #body-cell-selecionar="props">
            <q-td :props="props">
              <q-btn
                round
                no-caps
                color="red"
                dense
                icon="close"
                @click="removerProduto(props.row.id)"
              />
            </q-td>
          </template>
          <template #body-cell-imagem="props">
            <q-td :props="props">
              <div
                v-if="props.row.product_images.length != 0"
                class="img-container"
              >
                <q-img
                  v-if="props.row.product_images.length != 0"
                  :src="props.row.product_images[0].url"
                  fit="contain"
                  style="max-width: 100%; height: 45px"
                />
              </div>
              <div class="img-container" v-else>
                <span class="img-normal"></span>
              </div>
            </q-td>
          </template>
          <template #body-cell-codigo="props">
            <q-td :props="props">
              <span>{{ props.row?.code }}</span>
            </q-td>
          </template>
          <template #body-cell-nome="props">
            <q-td :props="props">
              <span>{{ props.row?.name }}</span>
            </q-td>
          </template>
          <template #body-cell-estoque="props">
            <q-td :props="props">
              <span>{{
                parseInt(props.row?.stock[0]?.pivot.amount).toFixed(2)
              }}</span>
            </q-td>
          </template>
          <template
            v-if="filtros.tipoRequisicao == 'liberados'"
            #body-cell-retirar="props"
          >
            <q-td>
              <span>{{
                `${props.row?.pode_retirar}(${
                  parseFloat(props.row?.max_amount) -
                    parseFloat(props.row?.withdrawal_amount) >
                  0
                    ? parseFloat(props.row?.max_amount) -
                      parseFloat(props.row?.withdrawal_amount)
                    : "0"
                })`
              }}</span>
            </q-td>
          </template>
          <template #body-cell-quantidade="props">
            <q-td :props="props">
              <div>
                <q-input
                  v-model.number="props.row.amount"
                  type="number"
                  style="width: 60px; max-width: 100px"
                  outlined
                  dense
                  min="0"
                />
              </div>
            </q-td>
          </template>
        </q-table>
      </div>
      <div
        class="row q-mt-lg text-brand-5 text-weight-bold text-body container-observacao"
      >
        <div class="col-8 text-area-input">
          <div class="q-ml-sm no-margin-no-padding">Observações</div>
          <q-input
            type="textarea"
            dense
            outlined
            v-model="requisicaoObservacao"
          />
        </div>
        <div class="row col-12 q-mt-md btn-requisicao-container">
          <q-btn
            class="btn-requisicao"
            label="Abrir Requisição"
            no-caps
            color="positive"
            :disable="criarRequisicao"
            icon="add"
            @click="abrirRequisicao()"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoFuncionario from "../../ferramentaria/components/SelecaoFuncionario.vue";

const columns = [
  {
    name: "selecionar",
    label: "Selecionar",
    align: "left",
    sortable: false,
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
    sortable: false,
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: false,
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
    sortable: true,
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    sortable: false,
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    sortable: false,
  },
];
const columns2 = [
  {
    name: "selecionar",
    label: "Remover",
    align: "left",
    sortable: false,
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
    sortable: false,
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: false,
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
    sortable: true,
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    sortable: false,
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    sortable: false,
  },
  {
    name: "retirar",
    label: "Pode Retirar?",
    align: "left",
    sortable: false,
  },
];

const store = useStore();
const quasar = useQuasar();
const router = useRouter();

const options = ref({
  requisicaoPara: [
    {
      label: "Colaborador",
      value: "colaborador",
    },
    {
      label: "Visitante",
      value: "visitante",
    },
  ],
});
const filtros = ref({
  requisicaoPara: {
    label: "Colaborador",
    value: "colaborador",
  },
  solicitante: "",
  tipoRequisicao: "",
  produto: "",
});
const selected = ref([]);
const listaCentros = ref([]);
const userLogado = ref("");
const listarTodos = ref(false);
const listaProdutos = ref([]);
const loading = ref(false);
const requisicaoObservacao = ref("");
const centroSelecionado = ref({});
const criarRequisicao = ref(false);

const escolherLista = async () => {
  if (
    filtros.value.tipoRequisicao == "liberados" &&
    filtros.value.requisicaoPara?.value == "colaborador" &&
    filtros.value.solicitante != ""
  ) {
    listarProdutosLiberados();
    return;
  }
  if (
    filtros.value.requisicaoPara == "colaborador" &&
    (filtros.value.solicitante?.matricula == "" ||
      filtros.value.solicitante?.matricula == undefined)
  ) {
    return;
  }
  if (
    filtros.value.tipoRequisicao != "" &&
    filtros.value.requisicaoPara?.value != "visitante" &&
    filtros.value.solicitante != ""
  ) {
    listarProdutos();
    return;
  }

  if (filtros.value.requisicaoPara?.value == "visitante") {
    listarProdutos();
    return;
  }
};

const listarProdutos = async () => {
  try {
    loading.value = true;
    const response = await store.dispatch("requisicao/listarProdutos", {
      vendor_id: store.state.org.unidadeData.id,
      per_page:
        filtros.value.requisicaoPara?.value == "visitante" ? undefined : 100,
      has_ca: filtros.value.tipoRequisicao,
      search: filtros.value.produto,
      plantiff_id:
        filtros.value.requisicaoPara?.value == "visitante"
          ? undefined
          : filtros.value.solicitante.idTabela,
    });
    if (listarTodos.value) {
      let lista = [];
      response.data.results.data.products.forEach((e) => {
        if (parseFloat(e?.stock[0]?.pivot.amount) > 0) {
          lista.push(e);
        }
      });
      listaProdutos.value = lista;
      loading.value = false;
      return;
    }
    listaProdutos.value = response.data.results.data.products;
    loading.value = false;
  } catch (error) {
    loading.value = false;
    console.log(error);
  }
};

const receberFuncionario = (value) => {
  filtros.value.solicitante = value;
};

const listarCentros = async () => {
  try {
    let response = await store.dispatch("requisicao/listarCentrosCustos", {
      vendor_id: store.state.org.unidadeData.id,
      per_page: 16,
      // search: filtroSolicitante.value,
    });

    listaCentros.value = response.data.results.data;
  } catch (error) {
    console.log(error);
  }
};

const receberDadoUserLogado = async () => {
  try {
    const response = await store.dispatch("requisicao/userLogado");
    userLogado.value = response.data;
  } catch (error) {
    console.log(error);
  }
};

const listarProdutosLiberados = async () => {
  try {
    const response = await store.dispatch(
      "requisicao/listarProdutosLiberados",
      {
        vendor_id: store.state.org.unidadeData.id,
        per_page: 100,
        user_id:
          filtros.value.solicitante.idTabela || filtros.value.solicitante.id,
        search: filtros.value.produto,
      }
    );
    if (listarTodos.value) {
      let lista = [];
      response.data.data.forEach((e) => {
        if (parseFloat(e.estoque) > 0) {
          lista.push({
            name: e.descricao,
            product_images: [],
            stock: [{ pivot: { amount: e.estoque } }],
            code: e.produto_codigo,
            id: e.produto_id,
            pode_retirar: e.pode_retirar,
            max_amount: e.max_amount,
            withdrawal_amount: e.withdrawal_amount,
          });
        }
      });
      listaProdutos.value = lista;
      loading.value = false;
      return;
    }
    const novoResponse = response.data.data.map((e) => {
      return {
        name: e.descricao,
        product_images: [],
        stock: [{ pivot: { amount: e.estoque } }],
        code: e.produto_codigo,
        id: e.produto_id,
        pode_retirar: e.pode_retirar,
        max_amount: e.max_amount,
        withdrawal_amount: e.withdrawal_amount,
      };
    });
    listaProdutos.value = novoResponse;
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const abrirRequisicao = async () => {
  criarRequisicao.value = true;
  try {
    await store.dispatch("requisicao/criarRequisicao", {
      cost_center_id:
        filtros.value.requisicaoPara?.value == "visitante"
          ? centroSelecionado.value?.id
          : filtros.value.solicitante?.centroCusto,
      description:
        requisicaoObservacao.value != ""
          ? requisicaoObservacao.value
          : undefined,
      plantiff_id:
        filtros.value.requisicaoPara?.value == "visitante"
          ? 2
          : filtros.value.solicitante?.idTabela ||
            filtros.value.solicitante?.id,
      products: selected.value,
      vendor_id: store.state.org.unidadeData.id,
    });
    resetarValores();
    quasar.notify({
      message: "Requisição feita com sucesso",
      color: "positive",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    criarRequisicao.value = false;
    router.push({ name: "backoffice/listagem-requisicoes-teste" });
  } catch (error) {
    criarRequisicao.value = false;
    quasar.notify({
      message: "Erro ao abrir Requisição",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const resetarValores = async () => {
  requisicaoObservacao.value = "";
  selected.value = [];
  listaProdutos.value = [];
};

const removerProduto = async (id) => {
  selected.value = selected.value.filter((produto) => produto.id != id);
};

watch(
  () => filtros.value.requisicaoPara,
  () => {
    if (filtros.value.requisicaoPara?.value == "visitante") {
      filtros.value.tipoRequisicao = "all";
      listarCentros();
    }
  }
);

watch(
  () => filtros.value.solicitante,
  () => {
    escolherLista();
  }
);

watch(
  () => listarTodos.value,
  () => {
    escolherLista();
  }
);

watch(
  () => filtros.value.produto,
  () => {
    escolherLista();
  }
);

watch(
  () => filtros.value.tipoRequisicao,
  () => {
    escolherLista();
  }
);

onMounted(() => {
  escolherLista();
  receberDadoUserLogado();
});
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
/* height of all previous header rows */
.img-container {
  border: 2px solid gray;
  border-radius: 5px;
  font-weight: bold;
  width: 50px;
  height: 50px;
}
.img-normal {
  max-width: 100%;
  height: 100%;
}
.texto-toggle {
  font-size: 14px;
}
@media only screen and (max-width: 635px) {
  .container {
    margin: 30px 0 0 0;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn-grid-container {
    padding: 0;
    margin: 0;
  }
  .img-container-grid {
    border: 2px solid #b4b4b4;
    border-radius: 5px;
    font-weight: bold;
    width: 90px;
    height: 110px;
  }
  .img-grid {
    max-width: 100%;
    height: 100%;
  }
  .text-titulo-grupo {
    font-size: 14px !important;
    width: 300px;
    margin-bottom: 20px;
  }
  .input-search-grupo {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .radio-grupo-produto {
    font-size: 12px;
  }
  .container-radio-solicitante {
    max-width: 160px;
  }
  .input-search-table {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .container-texto-input-search {
    font-size: 14px !important;
    width: 100%;
    margin-bottom: 20px;
  }
  .btn-quantidade {
    font-size: 7px;
    width: 5px;
  }
  .input-quantidade {
    margin: 0px;
    padding-left: 11px;
    font-size: 14px;
  }
  .input-quantidade-container {
    margin: 0px 0px 0px 0px;
    padding: 0px;
    height: 32px;
  }
  .text-area-input {
    width: 100%;
  }
  .btn-requisicao-container {
    margin: 15px 0 0 5px;
  }
  .btn-requisicao {
    margin: 0 8px 0 0;
    padding: 8px 10px 8px 5px;
    font-size: 13px !important;
    width: 171px;
    border-radius: 5px;
  }
  .container-observacao {
    margin: 20px 0px 0px 0px;
  }
  .titulo-input-unidade {
    font-size: 12px;
  }
  .titulo-input-tipo-requisicao {
    font-size: 12px;
  }
  .arrow {
    color: white;
    font-size: 25px;
    border-radius: 5px;
    cursor: pointer;
  }
}

@media only screen and (max-width: 368px) {
  .arrow {
    color: white;
    font-size: 21px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
